import { render } from "./SuccessIcon.vue?vue&type=template&id=c9d60a18&scoped=true"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"

import "./SuccessIcon.vue?vue&type=style&index=0&id=c9d60a18&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d60a18"]])

export default __exports__